import { useLocation, useNavigate } from "react-router-dom";
import { useStatementsContext } from "../context/statementsContext";
var useNavigateToStatements = function () {
    var location = useLocation();
    var navigate = useNavigate();
    var handleClose = useStatementsContext().handleClose;
    var navigateToStatements = function (_a) {
        var statementDate = _a.statementDate, statementInsert = _a.statementInsert;
        navigate("/statement?statementDate=".concat(statementDate).concat(statementInsert ? "&statementInsert=".concat(statementInsert) : ""), { state: { from: location.pathname + location.search } });
    };
    return function (params) {
        navigateToStatements(params);
        handleClose(true);
    };
};
export default useNavigateToStatements;
